import { FetchResult, gql } from 'apollo-boost';
import { IIpHolder } from '../../../models/ip-holder';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query IpHolder($uid: String!){
        ip_holder(uid: $uid) {
            uid,
            identifier,
            name,
            url,
            details,
            createdAt: created_at,
            updatedAt: updated_at,
            blockPhotoActivity: block_photo_activity,
            users: representatives {
                uid,
                email,
                firstName: first_name,
                lastName: last_name,
            },
            narratives: narratives {
                uid,
                title,
            },
        }
    }
`;

export async function getIpHolder(uid: string): Promise<IIpHolder> {
    const result: FetchResult<{ ip_holder: IIpHolder }> = await graphqlClient.query({
        query: QUERY,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.ip_holder;
}

